import { useEffect, useRef } from 'react';

type TApplicationFilesListener = () => void;

const applicationFilesListeners = new Map<string, Set<TApplicationFilesListener>>();

export const notifyGuaranteesApplicationFilesChanged = (applicationId?: string | null): void => {
  if (!applicationId) {
    return;
  }

  applicationFilesListeners.get(applicationId)?.forEach((listener) => listener());
};

export const useGuaranteesApplicationFilesSync = (
  applicationId: string | null | undefined,
  onApplicationFilesChanged: TApplicationFilesListener
): void => {
  const listenerRef = useRef(onApplicationFilesChanged);

  listenerRef.current = onApplicationFilesChanged;

  useEffect(() => {
    if (!applicationId) {
      return;
    }

    const listener = () => listenerRef.current();
    const listeners = applicationFilesListeners.get(applicationId) ?? new Set();

    listeners.add(listener);
    applicationFilesListeners.set(applicationId, listeners);

    return () => {
      listeners.delete(listener);

      if (!listeners.size) {
        applicationFilesListeners.delete(applicationId);
      }
    };
  }, [applicationId]);
};
